import React from "react";
import { MDBCol } from "mdbreact";

//Components
import Navbar from "../../components/Navbar_inicio";
import FooterPage from "../../components/Footer";

//CSS
import "./Inicio.css";

//Landing sections
import Start from "./sections/Start";

class InicioSecurity extends React.Component {
  render() {
    return (
      <div id="appp">
        <MDBCol style={{ padding: "0px" }}>
          <Navbar />
          <Start />
          <FooterPage />
        </MDBCol>
      </div>
    );
  }
}

export default InicioSecurity;
